function validate_form() {
    $('.prtf_achievement_form').form({
        fields: {
            name: {
                identifier: 'name',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Наименование достижение не должно быть пустым'
                    }
                ]
            },
            prtf_achievement_kind_id: {
                identifier: 'prtf_achievement_kind_id',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Вид достижения должен быть выбран'
                    }
                ]
            },
            date_start: {
                identifier: 'date_start',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Поле даты достижения не должно быть пустым'
                    }
                ]
            },
            name_document: {
                identifier: 'name_document',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Наименование файла не должно быть пустым'
                    }
                ]
            },
            date_start_document: {
                identifier: 'date_start_document',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Поле даты файла не должно быть пустым'
                    }
                ]
            },
            name_comment: {
                identifier: 'name_comment',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Наименование файла не должно быть пустым'
                    }
                ]
            },
            date_start_comment: {
                identifier: 'date_start_comment',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Поле даты файла не должно быть пустым'
                    }
                ]
            },
            name_work: {
                identifier: 'name_work',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Наименование файла не должно быть пустым'
                    }
                ]
            },
            date_start_work: {
                identifier: 'date_start_work',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Поле даты файла не должно быть пустым'
                    }
                ]
            }
        }
    });
}

document.addEventListener("turbolinks:load", validate_form );
document.addEventListener("turbolinks:load", function() {
    $('#documents').on('cocoon:after-insert', validate_form );
    $('#works').on('cocoon:after-insert', validate_form );
    $('#comments').on('cocoon:after-insert', validate_form );
});

